<template>
  <div>
    <el-dialog  :close-on-click-modal="false" title="增加用户" :append-to-body="true" :visible.sync="addDialogVisible" class="imgbox" width="50%" :before-close="resetForm">
      <el-form label-width="80px" ref="ruleForm"  :rules="rules" :model="form">
        <el-form-item label="用户名" prop="regName">
          <el-input v-model.trim="form.regName" autocomplete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="realName">
          <el-input v-model.trim="form.realName" autocomplete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
         <el-form-item label="组织" prop="organizationId" v-has="'user_permisson'">
          <el-select style="width:100%" v-model="form.organizationId">
            <el-option
              v-for="item in charactorOptions"
              :key="item.organizationId"
              :label="item.organizationName"
              :value="item.organizationId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="form.gender">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="form.email" autocomplete="off" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model.trim="form.phone" autocomplete="off" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { orgList } from '@/api/organization'
import { addUser } from '@/api/user'
import { emailVf, phoneVf } from '@/assets/js/validator'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      charactorOptions: [],
      form: {
        gender: '男'
      },
      rules: {
        regName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, validator: emailVf, trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, validator: phoneVf, trigger: ['blur', 'change'] }
        ],
        distributionProduct: [
          { required: true, message: '请选择分配产品', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    // 解决select设置多选(multiple) 触发formItem校验
    this.$set(this.form, 'charactor', [])
    this.$set(this.form, 'distributionProduct', [])
    const params = {
      pageSize: 50
    }
    orgList(params).then((res) => {
      this.charactorOptions = res.data.data.list
    })
  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log('可以调用接口了')
          const params = Object.assign({}, this.form)
          addUser(params).then((res) => {
            console.log(res)
            if (res.data.code === 200 || res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.$emit('closeAddDialog', 1)
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>

</style>
